/**
 * p2p_business_search
 * https://www.msmaster.qa.paypal.com/elmo/experiment/111963
 */

import * as pxp from 'lib/pxp'

export function isBizSearchTreatment() {
  return pxp.isTreatment('Trmt_p2p_business_search')
}
